// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IBuilderSeoDataSchema } from '../seo/BuilderSeoDataSchema';

export interface IBuilderForListPresenterSchema {
  /** Отображать телефон **/
  displayPhone?: boolean;
  /** ID **/
  id: number;
  /** URL логотипа **/
  logoUrl?: string;
  /** Статус модерации **/
  moderationStatus?: EModerationStatus;
  /** Название **/
  name: string;
  /** Телефон **/
  phone?: string;
  /** ЧПУ застройщика **/
  seo?: IBuilderSeoDataSchema;
}

export enum EModerationStatus {
  /** Удален **/
  Deleted = 'deleted',
  /** Черновик **/
  Draft = 'draft',
  /** Новый **/
  New = 'new',
  /** Опубликован **/
  Published = 'published',
}
